import React, { JSX } from "react";
import { Container } from "./SubmitButton.styled";
import { Typography } from "@mui/material";
import { colors } from "../../../../styles/theme";

export type SubmitButtonProps = {
  disabled?: boolean;
} & React.ComponentProps<typeof Container>;

export const SubmitButton: React.FC<SubmitButtonProps> = (
  props,
): JSX.Element => {
  const { children, disabled, ...rest } = props;
  return (
    <Container
      {...rest}
      sx={{
        cursor: disabled ? "not-allowed" : "pointer",
        opacity: disabled ? 0.5 : 1,
      }}
    >
      <Typography
        variant={"v5"}
        sx={{
          color: colors.background.v1,
          letterSpacing: "1px",
        }}
      >
        {children}
      </Typography>
    </Container>
  );
};
